import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  leaseJourneyLoading: false,
  leasedUnitDetails: [],
  selectedUnit: {
    leaseDetails: {},
    unitDetails: {},
  },
  selectedCommunityDetails: null,
  isCommunityDetailsLoading: false,
  openUnitDropdown: false,
};

const leaseJourneySlice = createSlice({
  name: "leaseJourney",
  initialState: { ...initialState },
  reducers: {
    updateLeaseJourney: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetLeaseJourney: () => {
      return { ...initialState };
    },
  },
});

export const { updateLeaseJourney, resetLeaseJourney } =
  leaseJourneySlice.actions;
export default leaseJourneySlice.reducer;
